<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f"><a id="page_vii">Contents</a></h2><a id="page_vii">
</a><p class="tocc"><a id="page_vii"></a><a href="#/xhtml/intro">Introduction to the English-Language Edition: Volodya</a></p>
<p class="tocchap1"><a href="#/xhtml/ch1"><span class="color1">ONE</span><br/>Life: <em>Speak, Memory</em></a></p>
<p class="tocchap1"><span href="#/xhtml/ch2" title="Link target outside of Sample"><span class="color1">TWO</span><br/>Reality: <em>The Gift, Look at the Harlequins!, The Real Life</em> of Sebastian Knight</span></p>
<p class="tocchap1"><span href="#/xhtml/ch3" title="Link target outside of Sample"><span class="color1">THREE</span><br/>The Oppressor and the Oppressed: <em>Invitation to a Beheading, Bend Sinister</em></span></p>
<p class="tocchap1"><span href="#/xhtml/ch4" title="Link target outside of Sample"><span class="color1">FOUR</span><br/>Cruelty: <em>Pnin</em></span></p>
<p class="tocchap1"><span href="#/xhtml/ch5" title="Link target outside of Sample"><span class="color1">FIVE</span><br/>Genius and Madness: <em>Pale Fire</em></span></p>
<p class="tocchap1"><span href="#/xhtml/ch6" title="Link target outside of Sample"><span class="color1">SIX</span><br/>Love: <em>Lolita</em></span></p>
<p class="tocchap1"><span href="#/xhtml/ch7" title="Link target outside of Sample"><span class="color1">SEVEN</span><br/>Heaven and Hell: <em>Ada or Ardor</em></span></p>
<p class="tocchap1"><span href="#/xhtml/notes" title="Link target outside of Sample"><em>Notes</em> Translated by Dorna Khazeni</span></p>
<p class="tocchap"><span href="#/xhtml/bibl" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="tocchap"><span href="#/xhtml/ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="tocchap"><span href="#/xhtml/cred" title="Link target outside of Sample"><em>Credits</em></span></p>
<p class="tocchap"><span href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a4797828